import { defu } from 'defu'
import type { CoreServerConfigTypes, CoreServerOptions } from '../types/serverOptions'

type CoreServerConfig = CoreServerConfigTypes extends { view: infer View } ? View : CoreServerOptions

// Keyed by object: Nitro gives each request its own runtime config copy, which may carry overrides.
const merged = new WeakMap<object, CoreServerConfig>()

/** Server only: the browser has the public half alone. */
export function coreServerConfig(config: { core?: unknown, public: { core?: unknown } }): CoreServerConfig {
    let result = merged.get(config)
    if (!result) {
        result = defu(config.core as object, config.public.core as object) as CoreServerConfig
        merged.set(config, result)
    }
    return result
}
